import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import Radio from "../RadioGroup/Radio/Radio";
import stl from "./CheckboxesGroup.module.css";
var CheckboxesGroup = function CheckboxesGroup(_ref) {
  var setAnswer = _ref.setAnswer,
    secondaryAnswer = _ref.secondaryAnswer,
    options = _ref.options,
    error = _ref.error,
    mainAnswer = _ref.mainAnswer,
    setError = _ref.setError;
  var _useTranslation = useTranslation(["web_survey"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.CheckboxesGroup
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("choose_one_reason", {
    ns: "web_survey"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.options, " ").concat(error && mainAnswer ? stl.shake : ""),
    onAnimationEnd: function onAnimationEnd(e) {
      return e.target.classList.remove(stl.shake);
    }
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Radio, {
      key: option.id,
      label: option.text,
      value: option.id,
      setAnswer: setAnswer,
      answers: secondaryAnswer,
      setError: setError,
      isCheckBox: true
    });
  })));
};
export default CheckboxesGroup;